import { Component, Input, OnDestroy, inject } from '@angular/core';
import { Badge } from '@app/achievements/model/badge.model';
import { AchievementsHttpService } from '@app/achievements/service/http/http.service';
import { BehaviorSubject, Subscription, tap } from 'rxjs';

@Component({
    selector: 'app-achievement',
    templateUrl: './achievement.component.html',
    styleUrls: ['./achievement.component.scss'],
    standalone: false
})
export class AchievementComponent implements OnDestroy {
    private readonly achievementsHttpService = inject(AchievementsHttpService);

    @Input() achievement!: Badge;

    downloading$ = new BehaviorSubject<boolean>(false);

    private readonly subscriptions$ = new Subscription();

    ngOnDestroy(): void {
        this.subscriptions$.unsubscribe();
    }

    shareLinkedin(): void {
        window.open(
            this.achievement.share.linkedInUrl,
            'targetWindow',
            'toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=250',
        );
    }

    downloadPdf(event$: MouseEvent) {
        event$.stopPropagation();

        if (this.downloading$.value === true) {
            return;
        }

        this.downloading$.next(true);
        this.subscriptions$.add(
            this.achievementsHttpService
                .downloadBadge(this.achievement.type, this.achievement.id)
                .pipe(tap(() => this.downloading$.next(false)))
                .subscribe(),
        );
    }
}
